module.exports = __webpack_public_path__ + "static/image/main/m/banner-1-1.ver2_0_2.jpg?bdf2e8c1";